module.exports = __webpack_public_path__ + "static/media/LA-GQ.0402fa64.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/LA-GQ.png
// module id = 258
// module chunks = 0